export function median(values) {
  const nums = (values || []).filter((v) => v !== null && v !== undefined && Number.isFinite(Number(v))).map(Number);
  if (!nums.length) return null;
  const sorted = [...nums].sort((a, b) => a - b);
  const mid = Math.floor(sorted.length / 2);
  return sorted.length % 2 ? sorted[mid] : (sorted[mid - 1] + sorted[mid]) / 2;
}

/**
 * District-school comparison for one charter: its peer rows (scored with the
 * same model), the peer median of each measure, and the median risk score.
 * `charterRow.school.peers` is [{ id, distanceMiles }] from the endpoint.
 */
export function peerBenchmark(charterRow, peerRowsById, indicators) {
  const peers = (charterRow?.school?.peers || [])
    .map(({ id, distanceMiles }) => {
      const row = peerRowsById.get(id);
      return row ? { row, distanceMiles } : null;
    })
    .filter(Boolean);
  const medians = Object.fromEntries(
    indicators.map((indicator) => [
      indicator.id,
      median(peers.map(({ row }) => row.school[indicator.sourceField])),
    ])
  );
  return {
    peers,
    medians,
    medianPoints: median(peers.map(({ row }) => row.points)),
  };
}

/** Peers with a lower risk score than the charter, nearest first. */
export function lowerRiskPeers(charterRow, benchmark, count = 3) {
  return (benchmark?.peers || [])
    .filter(({ row }) => row.points !== null && charterRow?.points !== null && row.points < charterRow.points)
    .sort((a, b) => a.distanceMiles - b.distanceMiles)
    .slice(0, count);
}
